import React, { useEffect, useRef } from "react";
import SortupDialog from "../common/SortupDialog";
import { FILE_TYPE_ID } from "../../lib/constants";
import Hls from "hls.js";
import { replaceVideoUrl, isMobileScreen } from "../../lib/utils";

interface VideoPreviewModalProps {
  videoSrc: string;
  isOpen: boolean;
  onClose: () => void;
  fileType: number;
}

const VideoPreviewModal: React.FC<VideoPreviewModalProps> = ({
  videoSrc,
  isOpen,
  onClose,
  fileType,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  videoSrc = replaceVideoUrl(videoSrc);

  useEffect(() => {
    if (isOpen && videoRef.current && FILE_TYPE_ID.VIDEO === fileType) {
      if (videoSrc.endsWith(".m3u8")) {
        if (Hls.isSupported()) {
          const hls = new Hls();
          hls.loadSource(videoSrc);
          hls.attachMedia(videoRef.current);
        } else if (videoRef.current) {
          // For Safari, which has native HLS support
          videoRef.current.src = videoSrc;
        }
      } else {
        videoRef.current.src = videoSrc;
      }
    }
  }, [videoSrc, isOpen, fileType]);

  if (!isOpen) return null;

  const isVideo = FILE_TYPE_ID.VIDEO === fileType;

  return (
    <SortupDialog
      isOpen={isOpen}
      onClose={onClose}
      header="Preview"
      bodyClassName={`p-0 h-[80vh] ${
        isMobileScreen ? "w-[90vw]" : "w-[45vw]"
      } overflow-hidden bg-black`}
    >
      <div className="w-full h-full flex justify-center items-center">
        {isVideo ? (
          <video
            ref={videoRef}
            controls
            autoPlay
            style={{
              background:
                "linear-gradient(to right, #060708, #5a6066, #060708)",
            }}
            className="max-w-full max-h-full object-contain"
            data-setup="{}"
          />
        ) : (
          <img
            src={videoSrc}
            alt="preview"
            className="max-w-full max-h-full object-contain"
          />
        )}
      </div>
    </SortupDialog>
  );
};

export default VideoPreviewModal;
